import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import StackIcon from "../StackIcon";

export default function Stack() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let live = true;
    api.get("/api/stack")
      .then(({ data }) => { if (live) setItems(data.items || []); })
      .catch(() => {});
    return () => { live = false; };
  }, []);

  return (
    <section className="section" id="stack">
      <div className="container-x">
        <div className="section-head reveal">
          <div className="section-head__title">
            <span className="eyebrow">Tools of trade</span>
            <h2>
              Tech stack
              <br />
              <span className="stroke">I lean on.</span>
            </h2>
          </div>
          <div className="section-head__aside">
            <p>
              The right tool for the job — pragmatic, tested in production, and
              chosen because it ships, not because it's trendy.
            </p>
          </div>
        </div>

        {items.length > 0 ? (
          <div className="stack">
            {items.map((s) => (
              <div key={s.id} className="stack__item reveal" title={s.label}>
                <StackIcon iconKey={s.iconKey} iconUrl={s.iconUrl} label={s.label} />
                <span className="label">{s.label}</span>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-muted">No items.</p>
        )}
      </div>
    </section>
  );
}
